import React, { useEffect, useMemo, useRef } from 'react';
import styles from './RepeatingFields.module.scss';
import { Icon } from 'antd';

const RepeatingFields = ({
  form,
  formKey,
  addButtonText,
  renderOneItem,
  onClickBtn,
  openText = '',
  style = {},
  isDisabled = false,
}) => {
  const { setFieldsValue, getFieldValue } = form;

  const allFieldsKeys = getFieldValue(formKey);
  const myBlockRef = useRef(null);

  const scrollToBottom = () => {
    if (myBlockRef.current) {
      myBlockRef.current.scrollTop = myBlockRef.current.scrollHeight;
    }
  };

  const add = () => {
    const keys = getFieldValue(formKey) || [];

    const nextId = keys.length > 0 ? Math.max(...keys) + 1 : 0;

    setFieldsValue({
      [formKey]: [...keys, nextId],
    });
  };

  const deleteItem = (k) => {
    const keys = getFieldValue(formKey);
    if (keys.length === 1) {
      return;
    }
    setFieldsValue({
      [formKey]: keys.filter((key) => key !== k),
    });
  };

  const allowDelete = useMemo(() => {
    if (allFieldsKeys?.length > 1) {
      return true;
    } else return false;
  }, [allFieldsKeys]);

  useEffect(() => {
    scrollToBottom();
  }, [allFieldsKeys]);

  return (
    <div className={styles.root}>
      <div
        className={styles.content}
        ref={myBlockRef}
        style={style}
      >
        {allFieldsKeys?.map((key) =>
          renderOneItem(key, allowDelete, deleteItem)
        )}
      </div>
      {!isDisabled && (
        <div className={styles.btns}>
          <div
            className={styles.btnAdd}
            onClick={add}
          >
            <Icon
              type="plus-circle"
              style={{ color: '#09A2F2' }}
            />
            {addButtonText}
          </div>
          {typeof onClickBtn === 'function' && openText && (
            <div
              className={styles.openBtn}
              onClick={onClickBtn}
            >
              <Icon
                type="plus-circle"
                style={{ color: 'white' }}
              />
              {openText}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default RepeatingFields;
